import { isNil } from 'lodash';

const validateCEP = (zipCode) => {
  if (isNil(zipCode)) return false;

  let cleanZipCode = zipCode?.replace(/\D/g, '');

  if (cleanZipCode.length !== 8) {
    return false;
  }

  if (cleanZipCode === '00000000') {
    return false;
  }

  let zipCodePattern = /^[0-9]{8}$/;

  return zipCodePattern.test(cleanZipCode);
};

export default validateCEP;
